import React, { lazy } from 'react'

import AssignmentIcon from '@material-ui/icons/Assignment'
import InsertDriveFileIcon from '@material-ui/icons/InsertDriveFile'
import { Group, RecentActors } from '@material-ui/icons'
import {
  BsFillBriefcaseFill,
  BsFillStarFill,
  BsFillFileBarGraphFill,
} from 'react-icons/bs'
import { MdCreditCard } from 'react-icons/md'
import { CgEditBlackPoint } from 'react-icons/cg'
import { GiHeartInside, GiFactory } from 'react-icons/gi'
import FlashOnIcon from '@material-ui/icons/FlashOn'
import MultilineChartIcon from '@material-ui/icons/MultilineChart'
import PhotoSizeSelectSmallIcon from '@material-ui/icons/PhotoSizeSelectSmall'
import WidgetsIcon from '@material-ui/icons/Widgets'
import {
  SiGoogleanalytics,
  SiCivicrm,
  SiCloudsmith,
  SiAwesomelists,
  SiLinuxfoundation,
  SiAsana,
  SiYoutubetv,
  SiSalesforce,
  SiOpenstreetmap,
  SiCrowdsource,
  SiGooglemessages,
  SiGooglenews,
  SiSuperuser,
  SiCkeditor4,
} from 'react-icons/si'
import { HiCubeTransparent } from 'react-icons/hi'
import { FaTrophy , FaImage, FaVideo, FaFingerprint } from 'react-icons/fa'
import { FiAlertCircle } from 'react-icons/fi'


// import { FcMindMap } from 'react-icons/fc';
import {
  FaListUl,
  FaPercent,
  FaAddressBook,
  FaPoll,
  FaCloudDownloadAlt,
  FaLocationArrow,
  FaSearchPlus,
  FaClipboardList,
  FaMapPin,
  FaMap,
  FaUser,
  FaCubes,
  FaDiceD20,
  FaMapMarkerAlt,
  FaBox,
  FaUserTie,
  FaMoneyBillAlt,
  FaNewspaper,
  FaSearch,
  FaList,
  FaTv,
  FaChartBar,
  FaMotorcycle,
  FaCreditCard,
  FaBroadcastTower,
  FaRainbow,
  FaToggleOn,
  FaChartLine,
  FaDatabase,
  FaPlayCircle,
  FaFolder,
  FaExchangeAlt,
  FaBarcode,
} from 'react-icons/fa'
import { AiFillCreditCard, AiOutlineMail } from 'react-icons/ai'
import { TbShoppingCartDiscount } from 'react-icons/tb'
import { TiChartBar } from 'react-icons/ti'
import DestinatairesM2 from 'src/container/MaestrosContainer/DestinatairesM2'
import RejectionReazon from '@auteco/container/Gluky/RejectionReazon'
import SparePartsContainer from '@auteco/container/SparePartsContainer'
import ConfigContainer from '@auteco/container/GvcContainer/ConfigContainer'
import IndicatorsContainer from '@auteco/container/GvcContainer/IndicatorsContainer'
import ActionsContainer from '@auteco/container/GvcContainer/ActionsContainer'
import EmailsContainer from '@auteco/container/TrakkuContainer/EmailsContainer'
import {
  GdcContainer,
  SnopConfigContainer,
  SnopContainer,
  SnopCreateGroupsContainer,
  SnopMarkingContainer,
  LuciaPaymentsContainer,
} from '@auteco/container'
import AxiomaContainer from '@auteco/container/AxiomaContainer/AxiomaContainer'
import AxiomaAuditorContainer from '@auteco/container/AxiomaAuditorcontainer/AxiomaAuditorContainer'
import { PdfGenerator } from '@auteco/components/gdcComponents/DetailedPlan/components/PdfGenerator'
import ControlDiasInventarioContainer from '@auteco/container/ReportsContainer/ControlDiasInventarioContainer'
import ComercialMercadoContainer from '@auteco/container/ReportsContainer/ComercialMercadoContainer'
import KpisContainerTvs from '@auteco/container/LeadsContainer/ScoreConfigContainerTvs'
import AxiomaBovedaDocsContainer from '../container/AxiomaBovedaDocsContainer/AxiomaBovedaDocsContainer'
import AxiomaBasculasContainer from '../container/AxiomaBasculasContainer/AxiomaBasculasContainer'
import AxiomaJerarquiasContainer from '../container/AxiomaJerarquiasContainer/AxiomaJerarquiasContainer'
import AxiomaValidadoresContainer from '../container/AxiomaValidadoresContainer/AxiomaValidadoresContainer'
import AxiomaReemplazantesContainer from '../container/AxiomaReemplazantesContainer/AxiomaReemplazantesContainer'
import AxiomaEspecificacionesContainer from '../container/AxiomaEspecificacionesContainer/AxiomaEspecificacionesContainer'
import AxiomaEscanerContainer from '../container/AxiomaEscanerContainer/AxiomaEscanerContainer'
import HuellaContainer from '../container/HuellaContainer/HuellaContainer'
import SostenibilidadBateriasContainer from '../container/SostenibilidadBateriasContainer/SostenibilidadBateriaContainer'
import SostenibilidadAguaContainer from '../container/SostenibilidadAguaContainer/SostenibilidadAguaContainer'
import SostenibilidadResiduosContainer from '../container/SostenibilidadResiduosContainer/SostenibilidadResiduosContainer'
import SostenibilidadConfigContainer from '../container/SostenibilidadConfigContainer/SostenibilidadConfigContainer'
import SostenibilidadEnergiaContainer from '../container/SostenibilidadEnergiaContainer/SostenibilidadEnergiaContainer'
import SostenibilidadGasContainer from '../container/SostenibilidadGasContainer/SostenibilidadGasContainer'
import SostenibilidadIndicadorContainer from '../container/SostenibilidadIndicadorContainer/SostenibilidadIndicadorContainer'
import SostenibilidadLlantasContainer from '../container/SostenibilidadLlantasContainer/SostenibilidadLlantasContainer'
import SostenibilidadRolesContainer from '../container/SostenibilidadRolesContainer/SostenibilidadRolesContainer'
import SostenibilidadUsuariosContainer from '../container/SostenibilidadUsuariosContainer/SostenibilidadUsuariosContainer'

import TomConfigUserContainer from '../container/TomConfigUserContainer/TomConfigUserContainer'
import TomDashboardContainer from '../container/TomDashboardContainer/TomDashboardContainer'

import RutaPagosContainers from '../container/RutaPagosContainer/RutaPagosContainer'
import RutaVendedoresContainer from '../container/RutaVendedoresContainer/RutaVendedoresContainer'
import RutaProductosParticipantes from '../container/RutaProductosParticipantes/RutaProductosParticipantes'
import RutaProductosRecompensasContainer from '../container/RutaProductosRecompensas/RutaProductosRecompensasContainer'
import RutaVentasContainer from '../container/RutaVentasContainer/RutaVentasContainer'  
import RutaSeguraRutasContainer from '../container/RutaSeguraRutasContainer/RutaSeguraRutasContainer'
import RutaSeguraUsuariosContainer from '../container/RutaSeguraUsuariosContainer/RutaSeguraUsuariosContainer'
import PreciosContainer from '../container/PreciosContainer/PreciosContainer'
import { PreciosListaPage } from '../container/PreciosContainer/PreciosPages'

import BusquedaContainer from '../container/BusquedaContainer/BusquedaContainer'

import * as paths from './paths'
import ZoneContainer from '../container/PolygonsContaier/ZoneContainer'
import BossesContainer from '../container/PolygonsContaier/BossesContainer'
import MapasContainer from '../container/PolygonsContaier/MapasContainer'
import TerritoriesContainer from '../container/PolygonsContaier/TerritoriesContainer'
import ManagerContainer from '../container/PolygonsContaier/ManagerContainer'
import BudgetsContainer from '../container/PolygonsContaier/BudgetsContainer'
import Segmentacion from '../container/MaestrosContainer/Segmentacion'
import Segmentation4w from '../container/MaestrosContainer/Segmentation4w'
import PricesContainer from '../container/MaestrosContainer/PricesContainer'
import LinesCointainer from '../container/MaestrosContainer/LinesContainer'
import Projections from '../container/MaestrosContainer/Projections'
import AdminContainer from '../container/AdminContainer/AdminUsers/AdminContainer'
import CredencialesContainer from '../container/AdminContainer/UpdatePassword'
import UsersContainer from '../container/AdminContainer/AdminUsers/UsersContainer'
import PermistContainer from '../container/AdminContainer/AdminUsers/PermistContainer'
import AdminReportsContainer from '../container/AdminContainer/AdminReports/AdminReportsContainer'
import AdminReportUserContainer from '../container/AdminContainer/AdminReports/AdminReportUserContainer'
import UsersInventoryContainer from '../container/AdminContainer/AdminUsersInventory/UsersInventoryContainer'
import SearchDocumentsContainer from '../container/ReportsContainer/SearchDocumentsContainer'
import SearchPQRsContainer from '../container/ReportsContainer/SearchPQRsContainer'
import ReportMobility from '../container/ReportsContainer/ReportMobility'
import ReportDataStudio from '../container/ReportsContainer/ReportDataStudio'
import ReportProviders from '../container/ReportsContainer/ReportProviders'
import BillsContainer from '../container/MaestrosContainer/BillsContainer'
import GlukyContainer from '../container/Gluky'

/** Containers Leads */
import LeadsContainer from '../container/LeadsContainer/LeadsContainer'
import EstablecimientosContainer from '../container/LeadsContainer/EstablecimientosContainer'
import EstablecimientosTVSContainer from '../container/LeadsContainer/EstablecimientosTVSContainer'
import CampanasContainer from '../container/LeadsContainer/CampanasContainer'
import VehiculosContainer from '../container/LeadsContainer/VehiculosContainer'
import DistribucionContainer from '../container/LeadsContainer/DistribucionContainer'
/** Containers Leads */

import LaunchContainer from '../container/MaestrosContainer/LaunchContainer'
import IpcContainer from '../container/MaestrosContainer/IpcContainer'
import RecoverContainer from '../container/Home/RecoverContainer'
import EmailContainer from '../container/Home/EmailContainer'
import GeminiPage from '../pages/GeminiPage/GeminiPage'
import ConsolidatedContainer from '../container/PolygonsContaier/ConsolidatedContainer'
import { permitsList } from '../constants/permits'
import BussninesUnitContainer from '../container/HomeDashboard/BussninesUnitContainer'
import ValueMapsContainer from '../container/InsigthContainer/ValueMaps/ValueMapsContainer'
import SalesManagoContainer from '../container/InsigthContainer/SalesManagoContainer'
import YoutubeContainer from '../container/InsigthContainer/YoutubeContainers/YoutubeContainer'
import LaunchContainerHigthMotos from '../container/MaestrosContainer/LaunchContainerHigthMotos'
import ValueMapsListContainer from '../container/InsigthContainer/ValueMaps/ValueMapsListContainer'
import YoutubeDetailContainer from '../container/InsigthContainer/YoutubeContainers/YoutubeDetailContainer'
import ReportBoardContainer from '../container/ReportsContainer/ReportsBoard'
import CreateInventoryUserContainer from '../container/AdminContainer/AdminUsersInventory/CreateInventoryUserContainer'
import UserDestinataireContainer from '../container/AdminContainer/AdminUsersInventory/UserDestinataireContainer'
import KpisContainer from '../container/LeadsContainer/ScoreConfigContainer'
import AdminFontsContainer from '../container/AdminContainer/AdminReports/AdminFontsContainer'
import ReportRequest from '../container/ReportsContainer/ReportRequest'
import AdminRequestReportContainer from '../container/AdminContainer/AdminReports/AdminRequestReportContainer'
import ReportRequestPermissions from '../container/ReportsContainer/ReportRequestPermissions'
import AdminReportRequestPermissions from '../container/AdminContainer/AdminReports/AdminReportRequestPermissions'
import PortalContainer from '../container/InsigthFactoryContainer/PortalContainer'
import InsigthContainer from '../container/InsigthFactoryContainer/InsigthContainer'
import NewEntriesContainer from '../container/InsigthFactoryContainer/NewEntriesContainer'
import EntriesQueueContainer from '../container/InsigthFactoryContainer/EntriesQueueContainer'
import QuestionsContainer from '../container/InsigthFactoryContainer/QuestionsContainer'
import DetailsContainer from '../container/InsigthFactoryContainer/DetailsContainer'
import TestAcceptContainer from '../container/InsigthFactoryContainer/TestAcceptContainer'
import UsersControlContainer from '../container/InsigthFactoryContainer/UsersControlContainer'
import ChangesContainer from '../container/InsigthFactoryContainer/ChangesContainer'
import PostVentaContainer from '../container/ReportsContainer/PostVentaContainer'
import MotomaxFinderContainer from '../container/ReportsContainer/MotomaxFinderContainer'
import ChannelsContainer from '../container/MaestrosContainer/ChannelsContainer'
import PromotionContainer from '../container/MaestrosContainer/PromotionContainer'
import PartnersContainer from '../container/GvcContainer/PartnersContainer'

import ControlDisponibilidadContainer from '../container/ReportsContainer/ControlDisponibilidadContainer'
import ControlFillRateContainer from '../container/ReportsContainer/ControlFillRateContainer'
import ControllNsProovedorContainer from '../container/ReportsContainer/ControlNsProovedorContainer'
import RutaAutecoDashboardContainer from '../container/RutaAutecoDashboard/RutaAutecoDashboardContainer'
import ImagesContainer from '../container/MediaGeneratorContainer/ImagesContainer'
import VideosContainer from '../container/MediaGeneratorContainer/VideosContainer'
import Usuarios from '../container/NitroProContainer/usuarios/Usuarios'
import InstruccionesAgente from '../container/NitroProContainer/instrucciones-agente/InstruccionesAgente'
import NitroProLibreria from '../container/NitroProContainer/libreria/NitroProLibreria'
import ModelosLora from '../container/NitroProContainer/modelos-lora/ModelosLora'
import ModelosFundacionales from '../container/NitroProContainer/modelos-fundacionales/ModelosFundacionales'
import Proyectos from '../container/NitroProContainer/proyectos/Proyectos'
import Generador from '../container/NitroProContainer/generador/Generador'

// Módulo de compras
import {
  ConfiguracionUsuariosContainer,
  LeadtimeContainer,
  CompraContainer,
  ConfiguracionModelosContainer,
  AdminModelosContainer,
  DesviacionCombinadaContainer,
  GraficoSellInContainer,
} from '../container/ComprasContainer'

const Login = lazy(() => import('../pages/HomePage/Login'))

const singleRoutes = [
  {
    path: paths.LOGIN,
    component: Login,
    exact: true,
  },
  {
    path: paths.LOGIN_2,
    component: Login,
    exact: false,
  },
  {
    path: paths.LOGIN_SEARCH_REPORT_ID,
    component: Login,
    exact: false,
  },
  {
    path: paths.LOGIN_URL_DATASTUDIO,
    component: Login,
    exact: false,
  },
  {
    path: paths.LOGIN_RECOVER,
    component: RecoverContainer,
    exact: true,
  },
  {
    path: paths.LOGIN_EMAIL,
    component: EmailContainer,
    exact: true,
  },
  {
    path: '/gemini',
    component: GeminiPage,
    exact: true,
  },
]

const sliderRouter = [
  {
    name: 'Home',
    label: 'home',
    collapse: false,
    show: false,
    exact: true,
    path: paths.HOME,
    icon: <SiCloudsmith color="white" size="22" />,
    component: BussninesUnitContainer,
    route: [],
  },
  {
    name: 'Home',
    label: 'home',
    collapse: false,
    show: false,
    exact: true,
    path: '/ss',
    icon: <SiCloudsmith color="white" size="22" />,
    component: BussninesUnitContainer,
    route: [],
  },
  {
    name: 'Administrador',
    label: 'Administrador',
    collapse: true,
    exact: true,
    show: false,
    icon: <SiCloudsmith color="white" size="22" />,
    route: [
      {
        name: 'Usuarios',
        label: 'Usuarios',
        path: paths.ADMIN_USERS,
        component: AdminContainer,
        icon: <SiAwesomelists color="white" size="13" />,
        permission: permitsList.ADMIN_USUARIOS,
        show: true,
        exact: true,
      },
      {
        name: 'Reportes',
        label: 'Reportes',
        path: paths.ADMIN_USERS_REPORTS,
        component: AdminReportsContainer,
        icon: <SiAsana color="white" size="13" />,
        permission: permitsList.ADMIN_USUARIOS,
        show: true,
        exact: true,
      },
      {
        name: 'Solicitudes Reportes',
        label: 'Solicitudes Reportes',
        path: paths.ADMIN_USERS_REPORTS_REQUEST,
        component: AdminRequestReportContainer,
        icon: <SiGooglenews color="white" size="13" />,
        permission: permitsList.ADMIN_USUARIOS,
        show: true,
        exact: true,
      },
      {
        name: 'Solicitudes Permisos',
        label: 'Solicitudes Permisos',
        path: paths.ADMIN_REQUEST_PERMISSIONS,
        component: AdminReportRequestPermissions,
        icon: <SiCkeditor4 color="white" size="13" />,
        permission: permitsList.ADMIN_USUARIOS,
        show: true,
        exact: true,
      },
      {
        name: 'Fuentes',
        label: 'Fuentes',
        path: paths.ADMIN_USERS_FONTS,
        component: AdminFontsContainer,
        icon: <SiCrowdsource color="white" size="13" />,
        permission: permitsList.ADMIN_USUARIOS,
        show: true,
        exact: true,
      },
      {
        name: 'Inventarios',
        label: 'Inventarios',
        path: paths.ADMIN_USERS_INVENTORY,
        component: UsersInventoryContainer,
        icon: (
          <InsertDriveFileIcon style={{ color: 'white', fontSize: '13px' }} />
        ),
        permission: permitsList.ADMIN_USER_INVENTARIO,
        show: true,
        exact: true,
      },
      {
        name: 'Inventarios',
        label: 'Inventarios2',
        path: paths.ADMIN_USERS_CREATOR_INVENTORY,
        component: CreateInventoryUserContainer,
        permission: null,
        show: false,
        exact: true,
      },
      {
        name: 'Recuperar Contraseña',
        label: 'recover',
        path: paths.ADMIN_USERS_PASSWORD,
        component: CredencialesContainer,
        // icon: <SiAsana color='white' size='15' />,
        permission: null,
        show: false,
        exact: true,
      },
      {
        name: 'Crear Contraseña',
        label: 'create User',
        path: paths.ADMIN_USERS_CREATOR,
        component: UsersContainer,
        // icon: <SiAsana color='white' size='15' />,
        permission: null,
        show: false,
        exact: true,
      },
      {
        name: '/adminusers/permits',
        label: 'permits User',
        path: paths.ADMIN_USERS_PERMITS,
        component: PermistContainer,
        // icon: <SiAsana color='white' size='15' />,
        permission: null,
        show: false,
        exact: true,
      },
      {
        name: '/admin/reports',
        label: 'permits User',
        path: paths.ADMIN_USERS_PERMISSION,
        component: AdminReportUserContainer,
        // icon: <SiAsana color='white' size='15' />,
        permission: null,
        show: false,
        exact: true,
      },
      {
        name: 'creator_ inventory_destinatary',
        label: 'creator',
        path: paths.ADMIN_USERS_DESTINATERIE,
        component: UserDestinataireContainer,
        // icon: <SiAsana color='white' size='15' />,
        permission: null,
        show: true,
        exact: true,
      },
    ],
  },
  {
    name: 'Polígonos',
    label: 'Polígonos',
    show: false,
    collapse: true,
    icon: <FaLocationArrow color="white" size="22" />,
    route: [
      {
        name: 'Zonas',
        label: 'Zonas',
        path: paths.POLYGONS_ZONE,
        component: ZoneContainer,
        icon: <FaMapPin color="white" size="13" />,
        permission: permitsList.ADMIN_ZONAS,
        show: false,
        exact: true,
      },
      {
        name: 'Territorios',
        label: 'Territorios',
        path: paths.POLYGONS_TERRITORIES,
        component: TerritoriesContainer,
        icon: <FaMap color="white" size="13" />,
        permission: permitsList.ADMIN_TERRITORIOS,
        show: false,
        exact: true,
      },
      {
        name: 'Jefes',
        label: 'Jefes',
        path: paths.POLYGONS_BOSSES,
        component: BossesContainer,
        icon: <FaUser color="white" size="13" />,
        permission: permitsList.ADMIN_JEFES,
        show: false,
        exact: true,
      },
      {
        name: 'Gerentes',
        label: 'Gerentes',
        path: paths.POLYGONS_MANAGERS,
        component: ManagerContainer,
        icon: <FaUserTie color="white" size="13" />,
        permission: permitsList.ADMIN_GERENTES,
        show: false,
        exact: true,
      },
      {
        name: 'Mapa',
        label: 'Mapa',
        path: paths.POLYGONS_MAPS,
        component: MapasContainer,
        icon: <SiOpenstreetmap color="white" size="13" />,
        permission: permitsList.MUNICIPIOS_CALCULOS,
        show: false,
        exact: true,
      },
      {
        name: 'Presupuestos',
        label: 'Presupuestos',
        path: paths.POLYGONS_BUDGETS,
        component: BudgetsContainer,
        icon: <FaClipboardList color="white" size="13" />,
        permission: permitsList.PRESUPUESTOS_COMERCIALES,
        show: false,
        exact: true,
      },
      {
        name: 'Consolidado',
        label: 'Consolidado',
        path: paths.POLYGONS_CONSOLIDATED,
        component: ConsolidatedContainer,
        icon: <FaMapMarkerAlt color="white" size="13" />,
        permission: permitsList.ADMIN_GERENTES,
        show: false,
        exact: true,
      },
    ],
  },
  {
    name: 'Maestro',
    label: 'Maestro',
    show: false,
    collapse: true,
    icon: <FaPoll color="white" size="22" />,
    route: [
      {
        name: 'Segmentación',
        label: 'Segmentación',
        path: paths.MAESTRO_SEGMENTATION,
        component: Segmentacion,
        icon: <FaBox color="white" size="13" />,
        permission: permitsList.SEGMENTACION_SEGMENTOS,
        show: true,
        exact: true,
      },
      {
        name: 'Segmentación 4W',
        label: 'Segmentacion4W',
        path: paths.MAESTRO_SEGMENTATION4W,
        component: Segmentation4w,
        icon: <SiLinuxfoundation color="white" size="13" />,
        permission: permitsList.SEGMENTACION_4W,
        show: true,
        exact: true,
      },
      {
        name: 'Precios',
        label: 'Precios',
        path: paths.MAESTRO_PRICES,
        component: PricesContainer,
        icon: <FaMoneyBillAlt color="white" size="13" />,
        permission: permitsList.SEGMENTACION_MAESTROS_PRECIOS,
        show: true,
        exact: true,
      },
      {
        name: 'Promociones',
        label: 'Promociones',
        path: paths.MAESTRO_PROMOTIONS,
        component: PromotionContainer,
        icon: <TbShoppingCartDiscount color="white" size="13" />,
        permission: permitsList.SEGMENTACION_MAESTROS_PRECIOS,
        show: true,
        exact: true,
      },
      {
        name: 'N Comerciales',
        label: 'Lineas',
        path: paths.MAESTRO_LINES,
        component: LinesCointainer,
        icon: <FaCubes color="white" size="13" />,
        permission: permitsList.SEGMENTACION_LINEAS,
        show: true,
        exact: true,
      },
      {
        name: 'Proyecciones',
        label: 'Proyecciones',
        path: paths.MAESTRO_PROJECTIONS,
        component: Projections,
        icon: <FaDiceD20 color="white" size="13" />,
        permission: permitsList.PROYECCION_INDUSTRIA,
        permission2: permitsList.PROYECCION_LANZAMIENTO,
        show: true,
        exact: true,
      },
      {
        name: 'Facturas',
        label: 'Clasificación de facturas',
        path: paths.MAESTRO_BILLNG_CLASS,
        component: BillsContainer,
        icon: <MdCreditCard color="white" size="13" />,
        permission: permitsList.FACTURAS_CLASES,
        show: true,
        exact: true,
      },
      {
        name: 'Lanzamiento',
        label: 'Lanzamiento',
        path: paths.MAESTRO_LAUNCH,
        component: LaunchContainer,
        icon: <FlashOnIcon style={{ color: 'white', fontSize: '13px' }} />,
        permission: permitsList.LANZAMIENTOS_REPORTES,
        show: true,
        exact: true,
      },
      {
        name: 'Lanzamiento Alta G',
        label: 'Lanzamiento',
        path: paths.MAESTRO_LAUNCH_HIGH,
        component: LaunchContainerHigthMotos,
        icon: <FlashOnIcon style={{ color: 'white', fontSize: '13px' }} />,
        permission: permitsList.LANZAMIENTOS_ALTA_GAMA,
        show: true,
        exact: true,
      },
      {
        name: 'I. IPC',
        label: 'Indicador IPC',
        path: paths.MAESTRO_INDICATORS,
        component: IpcContainer,
        icon: (
          <MultilineChartIcon style={{ color: 'white', fontSize: '13px' }} />
        ),
        permission: permitsList.INDICADORES_IPC,
        show: true,
        exact: true,
      },
      {
        name: 'Metros 2 y Canal',
        label: 'm2 y canal',
        path: paths.MAESTRO_M2,
        component: DestinatairesM2,
        icon: (
          <PhotoSizeSelectSmallIcon
            style={{ color: 'white', fontSize: '13px' }}
          />
        ),
        permission: permitsList.MASTER_M2,
        show: false,
        exact: true,
      },
      {
        name: 'Canales',
        label: 'canales',
        path: paths.CHANNELS,
        icon: <FaTv color="white" size="13px" />,
        component: ChannelsContainer,
        permission: permitsList.SEGMENTACION_CANALES,
        show: false,
        exact: true,
      },
    ],
  },
  {
    name: 'Reportes',
    label: 'Reports',
    show: false,
    collapse: true,
    icon: <FaCloudDownloadAlt color="white" size="22px" />,
    route: [
      {
        name: 'Company Reports',
        label: 'Compañia',
        path: paths.REPORTS_PROVIDERS,
        component: ReportProviders,
        icon: <BsFillBriefcaseFill color="white" size="13" />,
        permission: permitsList.REPORTE_PROVEEDORES,
        show: true,
        exact: true,
      },
      {
        name: 'Datastudio Reports',
        label: 'DataStudio',
        path: paths.REPORTS_DATASTUDIO,
        component: ReportDataStudio,
        icon: <SiGoogleanalytics color="white" size="13" />,
        permission: permitsList.REPORTE_DATASTUDIO,
        show: true,
        exact: true,
      },
      {
        name: 'Solicitud Reportes',
        label: 'Solicitud creación',
        path: paths.REQUEST_REPORTS,
        component: ReportRequest,
        icon: <SiGooglemessages color="white" size="13" />,
        permission: permitsList.REPORTE_DATASTUDIO,
        show: true,
        exact: true,
      },
      {
        name: 'Solicitud Permisos',
        label: 'Solicitud Permisos',
        path: paths.REQUEST_PERMISSIONS,
        component: ReportRequestPermissions,
        icon: <SiSuperuser color="white" size="13" />,
        permission: permitsList.REPORTE_DATASTUDIO,
        show: true,
        exact: true,
      },
      {
        name: 'Mobility Reports',
        label: 'Mobility',
        path: paths.REPORTS_MOBILITY,
        component: ReportMobility,
        icon: <SiCivicrm color="white" size="13" />,
        permission: permitsList.REPORTE_MOBILITY,
        show: true,
        exact: true,
      },
      {
        name: 'Junta Directiva',
        label: 'Junta',
        path: paths.REPORTS_BOARD,
        component: ReportBoardContainer,
        icon: <AssignmentIcon style={{ color: 'white', fontSize: '13px' }} />,
        permission: permitsList.BOARD_REPORTS,
        show: true,
        exact: true,
      },
      {
        name: 'PostVenta CSA',
        label: 'Repuestos PostVenta',
        path: paths.POSTVENTA_CSA,
        component: PostVentaContainer,
        icon: <AssignmentIcon style={{ color: 'white', fontSize: '13px' }} />,
        permission: permitsList.POSTVENTA_BUSCADOR,
        show: true,
        exact: true,
      },
      {
        name: 'Buscador MotoMax',
        label: 'buscador motomax',
        path: paths.MOTOMAX_FINDER,
        component: MotomaxFinderContainer,
        icon: <FaSearch color="white" fontSize="13px" />,
        permission: permitsList.MOTOMAX_BUSCADOR,
        show: true,
        exact: true,
      },
      {
        name: 'Torre de control',
        label: 'torre de control',
        component: MotomaxFinderContainer,
        icon: <FaBroadcastTower color="white" fontSize="13px" />,
        permission: permitsList.TORRE,
        show: true,
        exact: true,
        subItems: [
          {
            name: 'Disponibilidad',
            label: 'Disponibilidad.',
            path: paths.CONTROL_DISPONIBILIDAD,
            component: ControlDisponibilidadContainer,
            icon: <FaToggleOn style={{ color: 'white', fontSize: '13px' }} />,
            permission: permitsList.TORRE,
            show: true,
            exact: true,
          },
          {
            name: 'Fill Rate',
            label: 'Fill rate',
            path: paths.CONTROL_FILL_RATE,
            component: ControlFillRateContainer,
            icon: <FaRainbow color="white" fontSize="13px" />,
            permission: permitsList.TORRE,
            show: true,
            exact: true,
          },
          {
            name: 'NS Proovedor',
            label: 'NS Proovedor',
            path: paths.CONTROL_NS_PROOVEDOR_RATE,
            component: ControllNsProovedorContainer,
            icon: <FaChartBar color="white" fontSize="13px" />,
            permission: permitsList.TORRE,
            show: true,
            exact: true,
          },
          {
            name: 'Dias Inventario',
            label: 'Dias Inventario',
            path: paths.CONTROL_DIAS_INVENTARIO,
            component: ControlDiasInventarioContainer,
            icon: <FaChartLine color="white" fontSize="13px" />,
            permission: permitsList.TORRE,
            show: true,
            exact: true,
          },
        ],
      },
      {
        name: 'Comercial motos',
        label: 'comercial motos',
        component: MotomaxFinderContainer,
        icon: <FaMotorcycle color="white" fontSize="13px" />,
        permission: permitsList.COMERCIAL,
        show: true,
        exact: true,
        subItems: [
          {
            name: 'Mercado',
            label: 'Mercado.',
            path: paths.COMERCIAL_MERCADO,
            component: ComercialMercadoContainer,
            icon: <FaDatabase style={{ color: 'white', fontSize: '13px' }} />,
            show: true,
            exact: true,
          },
        ],
      },
    ],
  },
  {
    name: 'Buscador',
    label: 'Buscador',
    collapse: true,
    icon: <FaSearchPlus color="white" size="22px" />,
    show: false,
    route: [
      {
        name: 'Placa y Cédula',
        label: 'Buscador',
        path: paths.REPORTS_DOCUMENTS,
        component: SearchDocumentsContainer,
        icon: <FaAddressBook color="white" size="13" />,
        permission: permitsList.BUSCADOR_USUARIOS,
        show: true,
        exact: true,
      },
      {
        name: 'Buscador PQRs histórico',
        label: 'Buscador',
        path: paths.REPORTS_PQRS,
        component: SearchPQRsContainer,
        icon: <FaAddressBook color="white" size="13" />,
        permission: permitsList.BUSCADOR_PQRS,
        show: true,
        exact: true,
      },
    ],
  },
  {
    name: 'Insight',
    label: 'Fábrica Insight',
    show: false,
    collapse: true,
    icon: <GiHeartInside color="white" size="22px" />,
    route: [
      {
        name: 'Videos',
        label: 'videos',
        path: paths.INSIDE_YOUTUBE,
        component: YoutubeContainer,
        icon: <SiYoutubetv color="white" size="13" />,
        permission: permitsList.YOUTUBE,
        show: true,
        exact: true,
      },
      {
        name: 'Videos',
        label: 'videos',
        path: paths.INSIDE_DETAIL,
        component: YoutubeDetailContainer,
        icon: <SiYoutubetv color="white" size="13" />,
        permission: null,
        show: false,
        exact: true,
      },
      {
        name: 'Sales Manago',
        label: 'salesManago',
        path: paths.INSIDE_SALES_MANAGO,
        component: SalesManagoContainer,
        icon: <SiSalesforce color="white" size="13" />,
        permission: permitsList.SALES_MANAGO,
        show: true,
        exact: true,
      },
      {
        name: 'Mapa de Valor',
        label: 'mapa_valor',
        path: paths.MAP_VALUE,
        component: ValueMapsListContainer,
        icon: <TiChartBar color="white" size="13" />,
        permission: permitsList.VALUE_MAP,
        show: true,
        exact: true,
      },
      {
        name: 'Mapa de Valor detalle',
        label: 'mapa_valor detalle',
        path: paths.MAP_VALUE_DETAIL,
        component: ValueMapsContainer,
        icon: null,
        permission: null,
        show: false,
        exact: true,
      },
    ],
  },
  {
    name: 'Fábrica de Insights',
    label: 'Fábrica de Insights',
    show: false,
    collapse: true,
    icon: <GiFactory color="white" size="22" />,
    route: [
      {
        name: 'Portal Principal',
        label: 'Portal Principal',
        path: paths.INSIGHT_FACTORY,
        component: PortalContainer,
        icon: <FaSearch color="white" size="13" />,
        permission: permitsList.FABRICA_INSIGHTS,
        show: true,
        exact: true,
      },
      {
        name: 'Insights',
        label: 'insights',
        path: paths.INSIGHT,
        component: InsigthContainer,
        icon: <FaNewspaper color="white" size="13" />,
        permission: null,
        show: false,
        exact: true,
      },
      {
        name: 'Entradas nuevas',
        label: 'Entradas nuevas',
        path: paths.INSIGHT_NEW_ENTRIES,
        component: NewEntriesContainer,
        icon: <FaNewspaper color="white" size="13" />,
        permission: null,
        show: false,
        exact: true,
      },
      {
        name: 'Gestion de usuarios',
        label: 'gestion de usuarios',
        path: paths.INSIGHT_USERS,
        component: UsersControlContainer,
        icon: <FaNewspaper color="white" size="13" />,
        permission: null,
        show: false,
        exact: true,
      },
      {
        name: 'Entradas Pendientes',
        label: 'Entradas Pendientes',
        path: paths.INSIGHT_ENTRIES_QUEUE,
        icon: <FaList color="white" size="13" />,
        permission: permitsList.FABRICA_INSIGHTS,
        component: EntriesQueueContainer,
        show: true,
        exact: true,
      },
      {
        name: 'Cuestionario',
        label: 'cuestionario',
        component: QuestionsContainer,
        icon: <FaNewspaper color="white" size="13" />,
        path: paths.INSIGHT_QUESTIONS,
        show: false,
        exact: true,
        permission: null,
      },
      {
        name: 'Detalle de la entrada',
        label: 'detalle de la entrada',
        component: DetailsContainer,
        icon: <FaNewspaper color="white" size="13" />,
        path: paths.INSIGHT_DETAILS,
        show: false,
        exact: true,
        permission: null,
      },
      {
        name: 'Aceptar Pruebas',
        label: 'aceptar pruebas',
        component: TestAcceptContainer,
        icon: <FaNewspaper color="white" size="13" />,
        path: paths.INSIGHT_TEST_ACCEPT,
        show: false,
        exact: true,
        permission: null,
      },
      {
        name: 'Lista de Cambios',
        label: 'lista de cambios',
        component: ChangesContainer,
        path: paths.INSIGHT_CHANGES,
        show: false,
        exact: true,
        permission: null,
      },
    ],
  },
  
  {
    name: 'Leads',
    label: 'Leads',
    show: false,
    collapse: true,
    icon: <TiChartBar color="white" size="22px" />,
    route: [
      {
        name: 'Gestion Leads',
        label: 'Gestion Leads',
        path: paths.INSIDELEAD,
        component: LeadsContainer,
        icon: <FaListUl color="white" size="13" />,
        permission: permitsList.LEADS_ADMIN,
        show: true,
        exact: true,
      },
      {
        name: 'Establecimientos',
        label: 'Establecimientos',
        path: paths.ADMIN_USERS,
        component: AdminContainer,
        icon: <FaToggleOn style={{ color: 'white', fontSize: '13px' }} />,
        permission: permitsList.LEADS_ADMIN,
        show: true,
        exact: true,
        subItems: [
          {
            name: 'Victory +',
            label: 'Victory +',
            path: paths.INSIDELEAD_SOCIOS,
            component: EstablecimientosContainer,
            permission: permitsList.LEADS_ADMIN,
            show: true,
            exact: true,
          },
          {
            name: 'TVS',
            label: 'TVS',
            path: paths.INSIDELEAD_SOCIOS_TVS,
            component: EstablecimientosTVSContainer,
            permission: permitsList.LEADS_ADMIN,
            show: true,
            exact: true,
          }
        ],
      },
      {
        name: 'Campañas Leads',
        label: 'Campañas Leads',
        path: paths.INSIDELEAD_CAMPANA,
        component: CampanasContainer,
        icon: <FaPlayCircle color="white" size="13" />,
        permission: permitsList.LEADS_ADMIN,
        show: true,
        exact: true,
      },
      {
        name: 'Vehiculos',
        label: 'Vehiculos',
        path: paths.INSIDELEAD_VEHICULO,
        component: VehiculosContainer,
        icon: <FaMotorcycle color="white" size="13" />,
        permission: permitsList.LEADS_ADMIN,
        show: true,
        exact: true,
      },
      {
        name: 'Distribución',
        label: 'Distribución',
        path: paths.INSIDELEAD_DISTRIBUCION,
        component: DistribucionContainer,
        icon: <FaPercent color="white" size="13" />,
        permission: permitsList.LEADS_ADMIN,
        show: true,
        exact: true,
      },
      {
        name: 'KPIS',
        label: 'KPIS',
        path: paths.ADMIN_USERS,
        component: AdminContainer,
        icon: <FaPercent color="white" size="13" />,
        permission: permitsList.LEADS_ADMIN,
        show: true,
        exact: true,
        subItems: [
          {
            name: 'Victory +',
            label: 'Victory +',
            path: paths.INSIDELEAD_KPI,
            component: KpisContainer,
            permission: permitsList.LEADS_ADMIN,
            show: true,
            exact: true,
          },
          {
            name: 'TVS',
            label: 'TVS',
            path: paths.INSIDELEAD_KPI_TVS,
            component: KpisContainerTvs,
            permission: permitsList.LEADS_ADMIN,
            show: true,
            exact: true,
          }
        ],
      },
    ],
  },
  
  {
    name: 'Repuestos',
    label: 'repuestos',
    show: false,
    collapse: true,
    icon: <HiCubeTransparent color="white" size="22px" />,
    route: [
      {
        name: 'Analizador compras',
        label: 'demand',
        path: paths.SPARE_PARTS,
        component: SparePartsContainer,
        icon: <CgEditBlackPoint color="white" size="13" />,
        permission: permitsList.REPUESTOS_INFORMES,
        show: true,
        exact: true,
      },
    ],
  },
  {
    name: 'Busqueda IA',
    label: 'busqueda',
    show: false,
    collapse: true,
    icon: <HiCubeTransparent color="white" size="22px" />,
    route: [
      {
        name: 'Nueva busqueda',
        label: 'demand',
        path: paths.BUSQUEDA,
        component: BusquedaContainer,
        icon: <CgEditBlackPoint color="white" size="13" />,
        permission: permitsList.BUSQUEDA_IA,
        show: true,
        exact: true,
      },
    ],
  },
  {
    name: 'Sostenibilidad',
    label: 'sostenibilidad',
    show: false,
    permission: permitsList.SOSTENIBILIDAD,
    collapse: true,
    icon: <BsFillFileBarGraphFill color="white" size="22px" />,
    route: [
      {
        name: 'Indicadores',
        label: 'indicadores',
        path: paths.SOSTENIBILIDAD_INDICADOR,
        component: SostenibilidadIndicadorContainer,
        icon: <CgEditBlackPoint color="white" size="13" />,
        permission: permitsList.SOSTENIBILIDAD,
        show: true,
        exact: true,
      },
      {
        name: 'Baterías',
        label: 'Baterías',
        path: paths.SOSTENIBILIDAD_BATERIAS,
        component: SostenibilidadBateriasContainer,
        icon: <CgEditBlackPoint color="white" size="13" />,
        permission: permitsList.SOSTENIBILIDAD,
        show: true,
        exact: true,
      },
      {
        name: 'Llantas',
        label: 'llantas',
        path: paths.SOSTENIBILIDAD_LLANTAS,
        component: SostenibilidadLlantasContainer,
        icon: <CgEditBlackPoint color="white" size="13" />,
        permission: permitsList.SOSTENIBILIDAD,
        show: true,
        exact: true,
      },
      {
        name: 'Energía',
        label: 'energía',
        path: paths.SOSTENIBILIDAD_ENERGIA,
        component: SostenibilidadEnergiaContainer,
        icon: <CgEditBlackPoint color="white" size="13" />,
        permission: permitsList.SOSTENIBILIDAD,
        show: true,
        exact: true,
      },
      {
        name: 'Gas',
        label: 'gas',
        path: paths.SOSTENIBILIDAD_GAS,
        component: SostenibilidadGasContainer,
        icon: <CgEditBlackPoint color="white" size="13" />,
        permission: permitsList.SOSTENIBILIDAD,
        show: true,
        exact: true,
      },
      {
        name: 'Agua',
        label: 'agua',
        path: paths.SOSTENIBILIDAD_AGUA,
        component: SostenibilidadAguaContainer,
        icon: <CgEditBlackPoint color="white" size="13" />,
        permission: permitsList.SOSTENIBILIDAD,
        show: true,
        exact: true,
      },
      {
        name: 'Residuos',
        label: 'residuos',
        path: paths.SOSTENIBILIDAD_RESIDUOS,
        component: SostenibilidadResiduosContainer,
        icon: <CgEditBlackPoint color="white" size="13" />,
        permission: permitsList.SOSTENIBILIDAD,
        show: true,
        exact: true,
      },
      {
        name: 'Usuarios',
        label: 'usuarios',
        path: paths.SOSTENIBILIDAD_USUARIOS,
        component: SostenibilidadUsuariosContainer,
        icon: <CgEditBlackPoint color="white" size="13" />,
        permission: permitsList.SOSTENIBILIDAD,
        show: true,
        exact: true,
      },
      {
        name: 'Roles',
        label: 'roles',
        path: paths.SOSTENIBILIDAD_ROLES,
        component: SostenibilidadRolesContainer,
        icon: <CgEditBlackPoint color="white" size="13" />,
        permission: permitsList.SOSTENIBILIDAD,
        show: true,
        exact: true,
      },
      {
        name: 'Config',
        label: 'config',
        path: paths.SOSTENIBILIDAD_CONFIG,
        component: SostenibilidadConfigContainer,
        icon: <CgEditBlackPoint color="white" size="13" />,
        permission: permitsList.SOSTENIBILIDAD,
        show: true,
        exact: true,
      },
    ],
  },
  {
    name: 'TOM',
    label: 'TOM',
    show: false,
    collapse: true,
    icon: <HiCubeTransparent color="white" size="22px" />,
    permission: permitsList.TOM,
    route: [
      {
        name: 'Configuración usuarios',
        label: 'config',
        path: paths.TOM_CONFIG_USERS,
        component: TomConfigUserContainer,
        icon: <CgEditBlackPoint color="white" size="13" />,
        permission: permitsList.TOM,
        show: true,
        exact: true,
      },
      {
        name: 'Dashboard',
        label: 'dashboard',
        path: paths.TOM_DASHBOARD,
        component: TomDashboardContainer,
        icon: <CgEditBlackPoint color="white" size="13" />,
        permission: permitsList.TOM,
        show: true,
        exact: true,
      },

      
    ],
  },
  {
    name: 'Ruta Auteco',
    label: 'Ruta Auteco',
    show: false,
    collapse: true,
    icon: <FaTrophy color="white" size="22px" />,
    permission: permitsList.RUTA_AUTECO,
    route: [
      {
        name: 'Dashboard',
        label: 'dashboard',
        path: paths.RUTA_AUTECO_DASHBOARD,
        component: RutaAutecoDashboardContainer,
        icon: <CgEditBlackPoint color="white" size="13" />,
        permission: permitsList.RUTA_AUTECO,
        show: true,
        exact: true,
      },
      {
        name: 'Productos Participantes',
        label: 'productos',
        path: paths.RUTA_PRODUCTOS_PARTICIPANTES,
        component: RutaProductosParticipantes,
        icon: <CgEditBlackPoint color="white" size="13" />,
        permission: permitsList.RUTA_AUTECO,
        show: true,
        exact: true,
      },
      {
        name: 'Productos Recompensas',
        label: 'productos-recompensas',
        path: paths.RUTA_PRODUCTOS_RECOMPENSAS,
        component: RutaProductosRecompensasContainer,
        icon: <CgEditBlackPoint color="white" size="13" />,
        permission: permitsList.RUTA_AUTECO,
        show: true,
        exact: true,
      },
      {
        name: 'Pagos',
        label: 'pagos',
        path: paths.RUTA_PAGOS,
        component: RutaPagosContainers,
        icon: <CgEditBlackPoint color="white" size="13" />,
        permission: permitsList.RUTA_AUTECO,
        show: true,
        exact: true,
      },
      {
        name: 'Vendedores',
        label: 'vendedores',
        path: paths.RUTA_VENDEDORES,
        component: RutaVendedoresContainer,
        icon: <CgEditBlackPoint color="white" size="13" />,
        permission: permitsList.RUTA_AUTECO,
        show: true,
        exact: true,
      },
      {
        name: 'Ventas',
        label: 'ventas',
        path: paths.RUTA_VENTAS,
        component: RutaVentasContainer,
        icon: <CgEditBlackPoint color="white" size="13" />,
        permission: permitsList.RUTA_AUTECO,
        show: true,
        exact: true,
      },
    ],
  },
  {
    name: 'S&OP',
    label: 'S&OP',
    show: false,
    collapse: true,
    icon: <HiCubeTransparent color="white" size="22px" />,
    route: [
      {
        name: 'Configuración usuarios',
        label: 'config',
        path: paths.SNOP_CONFIG_USERS,
        component: SnopConfigContainer,
        icon: <CgEditBlackPoint color="white" size="13" />,
        permission: permitsList.SNOP,
        show: true,
        exact: true,
      },
      {
        name: 'Configuración materiales',
        label: 'config-materials',
        path: paths.SNOP_CONFIG_MATERIALS,
        component: SnopMarkingContainer,
        icon: <CgEditBlackPoint color="white" size="13" />,
        permission: permitsList.SNOP,
        show: true,
        exact: true,
      },
      {
        name: 'Grupos y perfiles',
        label: 'grupos',
        path: paths.SNOP_GROUPS,
        component: SnopCreateGroupsContainer,
        icon: <CgEditBlackPoint color="white" size="13" />,
        permission: permitsList.SNOP,
        show: true,
        exact: true,
      },
      {
        name: 'Planeación de la demanda',
        label: 'demand',
        path: paths.SNOP_HOME,
        component: SnopContainer,
        icon: <CgEditBlackPoint color="white" size="13" />,
        permission: permitsList.SNOP,
        show: true,
        exact: true,
      },
    ],
  },
  {
    name: 'Gluky',
    label: 'Gluky',
    show: false,
    collapse: true,
    icon: <BsFillStarFill color="white" size="22px" />,
    route: [
      {
        name: 'Puntos Gluky',
        label: 'puntos',
        path: paths.REPORTS_GLUKY,
        component: GlukyContainer,
        icon: <CgEditBlackPoint color="white" size="13" />,
        permission: permitsList.GLULY,
        show: true,
        exact: true,
      },
      {
        name: 'Gluky Reject',
        label: 'Reject',
        path: paths.REPORTS_GLUKY_REJECT,
        component: RejectionReazon,
        icon: <WidgetsIcon style={{ color: 'white', fontSize: '13px' }} />,
        permission: permitsList.GLUKY_SEARCH_POINTS,
        show: true,
        exact: true,
      },
    ],
  },
  {
    name: 'Generación de Valor',
    label: 'Generación de Valor',
    icon: <Group style={{ color: 'white', fontSize: '22px' }} />,
    show: false,
    collapse: true,
    route: [
      {
        name: 'Encuestas',
        label: 'Encuestas',
        path: paths.GVC_JEFES,
        component: PartnersContainer,
        icon: <RecentActors style={{ color: 'white', fontSize: '13px' }} />,
        permission: permitsList.GVC_ADMIN,
        show: false,
        exact: true,
      },
      {
        name: 'Configuración',
        label: 'Configuración',
        path: paths.GVC_CONFIG,
        component: ConfigContainer,
        icon: <RecentActors style={{ color: 'white', fontSize: '13px' }} />,
        permission: permitsList.GVC_CONFIG,
        show: false,
        exact: true,
      },
      {
        name: 'Indicadores',
        label: 'Indicadores',
        path: paths.GVC_INDICATORS,
        component: IndicatorsContainer,
        icon: <RecentActors style={{ color: 'white', fontSize: '13px' }} />,
        permission: permitsList.GVC_ADMIN,
        show: false,
        exact: true,
      },
      {
        name: 'Acciones de mejora',
        label: 'Acciones de mejora',
        path: paths.GVC_ACTIONS,
        component: ActionsContainer,
        icon: <RecentActors style={{ color: 'white', fontSize: '13px' }} />,
        permission: permitsList.GVC_ACTIONS,
        show: false,
        exact: true,
      },
    ],
  },
  // {
  //   name: 'Nitro Pixel',
  //   label: 'nitro-pixel',
  //   show: false,
  //   collapse: true,
  //   icon: <FaImage color="white" size="22px" />,
  //   route: [
  //     {
  //       name: 'Imágenes',
  //       label: 'imagenes',
  //       path: paths.MEDIA_GENERATOR_IMAGES,
  //       component: ImagesContainer,
  //       icon: <FaImage color="white" size="13" />,
  //       permission: permitsList.IA_GENERATIVA,
  //       show: true,
  //       exact: true,
  //     },
  //     {
  //       name: 'Videos',
  //       label: 'videos',
  //       path: paths.MEDIA_GENERATOR_VIDEOS,
  //       component: VideosContainer,
  //       icon: <FaVideo color="white" size="13" />,
  //       permission: permitsList.IA_GENERATIVA,
  //       show: true,
  //       exact: true,
  //     },
  //   ],
  // },
  // {
  //   name: 'Nitro Pixel Pro',
  //   label: 'nitro-pixel-pro',
  //   collapse: true,
  //   icon: <FaRainbow color="white" size="22px" />,
  //   show: true,
  //   route: [
  //     {
  //       name: 'usuarios',
  //       label: 'usuarios',
  //       path: paths.NITROPIXEL_PRO_USUARIOS,
  //       component: Usuarios,
  //       icon: <FaUser color="white" size="13" />,
  //       permission: permitsList.NITROPIXEL_PRO,
  //       show: true,
  //       exact: true,
  //     },
  //     {
  //       name: 'instrucciones-agente',
  //       label: 'instrucciones-agente',
  //       path: paths.NITROPIXEL_PRO_INSTRUCCIONES_AGENTE,
  //       component: InstruccionesAgente,
  //       icon: <FaList color="white" size="13" />,
  //       permission: permitsList.NITROPIXEL_PRO,
  //       show: true,
  //       exact: true,
  //     },
  //     {
  //       name: 'libreria',
  //       label: 'libreria',
  //       path: paths.NITROPIXEL_PRO_LIBRERIA,
  //       component: NitroProLibreria,
  //       icon: <FaImage color="white" size="13" />,
  //       permission: permitsList.NITROPIXEL_PRO,
  //       show: true,
  //       exact: true,
  //     },
  //     {
  //       name: 'modelos-lora',
  //       label: 'modelos-lora',
  //       path: paths.NITROPIXEL_PRO_MODELOS_LORA,
  //       component: ModelosLora,
  //       icon: <FaCubes color="white" size="13" />,
  //       permission: permitsList.NITROPIXEL_PRO,
  //       show: true,
  //       exact: true,
  //     },
  //     {
  //       name: 'modelos-fundacionales',
  //       label: 'modelos-fundacionales',
  //       path: paths.NITROPIXEL_PRO_MODELOS_FUNDACIONALES,
  //       component: ModelosFundacionales,
  //       icon: <FaCubes color="white" size="13" />,
  //       permission: permitsList.NITROPIXEL_PRO,
  //       show: true,
  //       exact: true,
  //     },
  //     {
  //       name: 'proyectos',
  //       label: 'proyectos',
  //       path: paths.NITROPIXEL_PRO_PROYECTOS,
  //       component: Proyectos,
  //       icon: <FaFolder color="white" size="13" />,
  //       permission: permitsList.NITROPIXEL_PRO,
  //       show: true,
  //       exact: true,
  //     },
  //     {
  //       name: 'generador',
  //       label: 'generador',
  //       path: paths.NITROPIXEL_PRO_GENERADOR,
  //       component: Generador,
  //       icon: <FaImage color="white" size="13" />,
  //       permission: permitsList.NITROPIXEL_PRO,
  //       show: true,
  //       exact: true,
  //     },
  //   ],
  // },
  {
    name: 'Trakku',
    label: 'Trakku',
    collapse: true,
    icon: <FaMotorcycle color="white" size="22px" />,
    show: false,
    route: [
      {
        name: 'Configuración correos',
        label: 'Configuración correos',
        path: paths.TRAKKU_EMAILS,
        component: EmailsContainer,
        icon: <AiOutlineMail color="white" size="13" />,
        permission: permitsList.TRAKKU,
        show: true,
        exact: true,
      },
    ],
  },
  {
    name: 'Pagos',
    label: 'pagos',
    collapse: true,
    icon: <FaCreditCard color="white" size="22px" />,
    show: false,
    route: [
      {
        name: 'Facturación Lucia',
        label: 'facturacion',
        path: paths.LUCIA_PAYMENT,
        component: LuciaPaymentsContainer,
        icon: <AiFillCreditCard color="white" size="13" />,
        permission: permitsList.FACTURACION,
        show: true,
        exact: true,
      },
    ],
  },
  {
    name: 'Módulo de compras',
    label: 'compras',
    collapse: true,
    icon: <FaBox color="white" size="22px" />,
    show: false,
    route: [
      {
        name: 'Configuración usuarios',
        label: 'config-usuarios',
        path: paths.COMPRAS_CONFIG_USUARIOS,
        component: ConfiguracionUsuariosContainer,
        icon: <FaUserTie color="white" size="13" />,
        permission: permitsList.MOTOS_SYOP,
        show: true,
        exact: true,
      },
      {
        name: 'Leadtime',
        label: 'leadtime',
        path: paths.COMPRAS_LEADTIME,
        component: LeadtimeContainer,
        icon: <FaChartLine color="white" size="13" />,
        permission: permitsList.MOTOS_SYOP,
        show: true,
        exact: true,
      },
      {
        name: 'Desviación combinada',
        label: 'desviacion-combinada',
        path: paths.COMPRAS_DESVIACION_COMBINADA,
        component: DesviacionCombinadaContainer,
        icon: <FaChartBar color="white" size="13" />,
        permission: permitsList.MOTOS_SYOP,
        show: true,
        exact: true,
      },
      {
        name: 'Gráfico Sell In',
        label: 'grafico-sell-in',
        path: paths.COMPRAS_GRAFICO_SELL_IN,
        component: GraficoSellInContainer,
        icon: <MultilineChartIcon style={{ color: 'white', fontSize: '13px' }} />,
        permission: permitsList.MOTOS_SYOP,
        show: true,
        exact: true,
      },
      {
        name: 'Configuración Modelos',
        label: 'config-modelos',
        path: paths.COMPRAS_CONFIG_MODELOS,
        component: ConfiguracionModelosContainer,
        icon: <FaCubes color="white" size="13" />,
        permission: permitsList.MOTOS_SYOP,
        show: true,
        exact: true,
      },
      {
        name: 'Administración de Modelos',
        label: 'admin-modelos',
        path: paths.COMPRAS_ADMIN_MODELOS,
        component: AdminModelosContainer,
        icon: <FaCubes color="white" size="13" />,
        permission: permitsList.MOTOS_SYOP,
        show: true,
        exact: true,
      },
      {
        name: 'Compra',
        label: 'compra',
        path: paths.COMPRAS_COMPRA,
        component: CompraContainer,
        icon: <FaMoneyBillAlt color="white" size="13" />,
        permission: permitsList.MOTOS_SYOP,
        show: true,
        exact: true,
      },
      
     
    ],
  },
  {
    name: 'GDC',
    label: 'gdc',
    collapse: true,
    icon: <FaMotorcycle color="white" size="22px" />,
    show: false,
    route: [
      {
        name: 'Gestion desarrollo',
        label: 'Gestion',
        path: paths.GDC_HOME,
        component: GdcContainer,
        icon: <AiOutlineMail color="white" size="13" />,
        permission: permitsList.GVC_ADMIN,
        show: true,
        exact: true,
      },
      {
        name: 'PDF',
        label: 'PDF',
        path: paths.GDC_PDF,
        component: PdfGenerator,
        permission: permitsList.PDF,
        show: false,
        exact: true,
      },
    ],
  },
  {
    name: 'Axioma',
    label: 'axioma',
    collapse: true,
    icon: <FaMotorcycle color="white" size="22px" />,
    show: false,
    route: [
      {
        name: 'Validadores',
        label: 'validadores',
        path: paths.AXIOMA_VALIDADORES,
        component: AxiomaValidadoresContainer,
        icon: <FiAlertCircle color="white" size="13" />,
        permission: permitsList.AXIOMA_AUDITOR,
        show: true,
        exact: true,
      },
      {
        name: 'Bóveda de Documentos',
        label: 'boveda-docs',
        path: paths.AXIOMA_BOVEDA_DOCS,
        component: AxiomaBovedaDocsContainer,
        icon: <FaFolder color="white" size="13" />,
        permission: permitsList.AXIOMA_JERARQUIAS,
        show: true,
        exact: true,
      },
      {
        name: 'Básculas',
        label: 'basculas',
        path: paths.AXIOMA_BASCULAS,
        component: AxiomaBasculasContainer,
        icon: <FaBox color="white" size="13" />,
        permission: permitsList.AXIOMA_AXIOMER,
        show: true,
        exact: true,
      },
      {
        name: 'Jerarquías',
        label: 'jerarquias',
        path: paths.AXIOMA_JERARQUIAS,
        component: AxiomaJerarquiasContainer,
        icon: <FaList color="white" size="13" />,
        permission: permitsList.AXIOMA_JERARQUIAS,
        show: true,
        exact: true,
      },
      {
        name: 'Auditor',
        label: 'auditor',
        path: paths.AXIOMA_AUDITOR,
        component: AxiomaAuditorContainer,
        icon: <AiOutlineMail color="white" size="13" />,
        permission: permitsList.AXIOMA_AUDITOR,
        show: true,
        exact: true,
      },
      {
        name: 'Axiomer',
        label: 'axiomer',
        path: paths.AXIOMA_AXIOMER,
        component: AxiomaContainer,
        icon: <AiOutlineMail color="white" size="13" />,
        permission: permitsList.AXIOMA_AXIOMER,
        show: true,
        exact: true,
      },
      {
        name: 'Reemplazantes',
        label: 'reemplazantes',
        path: paths.AXIOMA_REEMPLAZANTES,
        component: AxiomaReemplazantesContainer,
        icon: <FaExchangeAlt color="white" size="13" />,
        permission: permitsList.AXIOMA_AXIOMER,
        show: true,
        exact: true,
      },
      {
        name: 'Especificaciones',
        label: 'especificaciones',
        path: paths.AXIOMA_ESPECIFICACIONES,
        component: AxiomaEspecificacionesContainer,
        icon: <FaClipboardList color="white" size="13" />,
        permission: permitsList.AXIOMA_JERARQUIAS,
        show: true,
        exact: true,
      },
      {
        name: 'Escáner',
        label: 'escaner',
        path: paths.AXIOMA_ESCANER,
        component: AxiomaEscanerContainer,
        icon: <FaBarcode color="white" size="13" />,
        permission: permitsList.AXIOMA_ESCANER,
        show: true,
        exact: true,
      },
    ],
  },
  {
    name: 'Ruta Segura',
    label: 'ruta-segura',
    collapse: true,
    icon: <FaMap color="white" size="22px" />,
    show: false,
    permission: permitsList.RUTA_SEGURA,
    route: [
      {
        name: 'Rutas',
        label: 'rutas',
        path: paths.RUTA_SEGURA_RUTAS,
        component: RutaSeguraRutasContainer,
        icon: <FaMap color="white" size="13" />,
        permission: permitsList.RUTA_SEGURA,
        show: true,
        exact: true,
      },
      {
        name: 'Usuarios',
        label: 'usuarios',
        path: paths.RUTA_SEGURA_USUARIOS,
        component: RutaSeguraUsuariosContainer,
        icon: <FaUser color="white" size="13" />,
        permission: permitsList.RUTA_SEGURA,
        show: true,
        exact: true,
      },
    ],
  },
  {
    name: 'Precios y Promos',
    label: 'precios',
    collapse: true,
    icon: <MdCreditCard color="white" size="22px" />,
    show: false,
    permission: permitsList.PRECIOS,
    permission2: permitsList.PRECIOS_ADMIN,
    route: [
      {
        name: 'Centralizador',
        label: 'centralizador',
        path: paths.PRECIOS_CENTRALIZADOR,
        component: PreciosContainer,
        icon: <CgEditBlackPoint color="white" size="13" />,
        permission: permitsList.PRECIOS,
        permission2: permitsList.PRECIOS_ADMIN,
        show: true,
        exact: true,
      },
      {
        name: 'Lista a socios',
        label: 'precios-lista',
        path: paths.PRECIOS_LISTA,
        component: PreciosListaPage,
        icon: <CgEditBlackPoint color="white" size="13" />,
        permission: permitsList.PRECIOS_TRADE,
        permission2: permitsList.PRECIOS_ADMIN,
        show: true,
        exact: true,
      },
    ],
  },
  {
    name: 'Huella',
    label: 'huella',
    collapse: true,
    icon: <FaFingerprint color="white" size="22px" />,
    show: false,
    permission: permitsList.HUELLA,
    route: [
      {
        name: 'Generador',
        label: 'huella-generador',
        path: paths.HUELLA,
        component: HuellaContainer,
        icon: <FaFingerprint color="white" size="13" />,
        permission: permitsList.HUELLA,
        show: true,
        exact: true,
      },
    ],
  },
]

const routes = {
  singleRoutes,
  sliderRouter,
}

export default routes
